import React from 'react';
import '../toolbar/BoardRefreshContextMenu.css';

/**
 * Checkbox "Somente técnicos com OS" para o menu de atualização do Board.
 * Visual estilo Mscad (círculo + check), cores do menu.
 * @param {{ checked: boolean, onChange: function(boolean), onCloseMenu?: function, disabled?: boolean }} props
 */
export function BoardOnlyTechniciansWithOSCheckbox({
  checked,
  onChange,
  onCloseMenu,
  disabled = false,
}) {
  const handleChange = (e) => {
    if (disabled) return;
    const next = e.target.checked;
    onChange(next);
    if (onCloseMenu) onCloseMenu();
  };

  return (
    <label
      className={[
        'refresh-context-menu-check-label',
        disabled ? 'is-disabled' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      title={
        disabled
          ? 'Disponível quando houver colunas de técnicos no quadro'
          : undefined
      }
    >
      <input
        type="checkbox"
        className="refresh-context-menu-check-native"
        checked={!!checked}
        disabled={disabled}
        onChange={handleChange}
        aria-label="Somente técnicos com OS"
      />
      <span className="refresh-context-menu-check-box" aria-hidden />
      <span className="refresh-context-menu-check-text">Somente técnicos com OS</span>
    </label>
  );
}

export default BoardOnlyTechniciansWithOSCheckbox;
